import { GET_LEADS, SET_LEADS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false,
};

const leadsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEADS:
      return { ...state, isLoading: true };
    case SET_LEADS:
      return {
        ...state,
        list: action.leads,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default leadsReducer;
